var _path, _path2, _path3, _path4, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidDocumentCut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 67,
    viewBox: "0 0 105 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.656 47L103.656 55.6555C103.656 61.1783 99.1791 65.6555 93.6562 65.6555L85.0008 65.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L93.6555 1C99.1783 1 103.655 5.47715 103.655 11V19.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.6555L1 11C0.999999 5.47715 5.47715 0.999994 11 0.999994L19.6555 0.999993",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 65.6555L11.0008 65.6555C5.47794 65.6555 1.00079 61.1783 1.00079 55.6555L1.00079 47",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_3178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 65,
    rx: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_3178)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bf_212_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3926 22.9653C30.9063 15.6018 37.4164 10.1273 44.7589 10.8842L77.9843 14.3095C79.21 14.4359 80.4473 14.3881 81.6595 14.1677L91.9372 12.2991C99.9532 10.8416 107.332 16.9998 107.332 25.1472V37.9427C107.332 44.5411 102.41 50.1027 95.8604 50.9047L82.832 52.5H42.3337C34.7636 52.5 28.7797 46.084 29.3065 38.5323L30.3926 22.9653Z",
    fill: "url(#paint0_linear_212_3178)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_212_3178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 5.0144,
    width: 91,
    height: 55,
    rx: 8,
    fill: "url(#paint1_linear_212_3178)",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_212_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5 23C67.5 22.1716 68.1716 21.5 69 21.5H104C104.828 21.5 105.5 22.1716 105.5 23C105.5 23.8284 104.828 24.5 104 24.5H69C68.1716 24.5 67.5 23.8284 67.5 23Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_212_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 31C68 30.4477 68.4477 30 69 30H104C104.552 30 105 30.4477 105 31C105 31.5523 104.552 32 104 32H69C68.4477 32 68 31.5523 68 31Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_212_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7109 39.1083C67.7109 38.556 68.1587 38.1083 68.7109 38.1083H87.9747C88.527 38.1083 88.9747 38.556 88.9747 39.1083C88.9747 39.6606 88.527 40.1083 87.9747 40.1083H68.7109C68.1587 40.1083 67.7109 39.6606 67.7109 39.1083Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_212_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0253 30.1099C47.1665 30.0972 47.3206 30.0972 47.4491 30.1099C50.5056 30.0088 52.9328 27.5446 52.9457 24.5117C52.9457 21.4156 50.39 18.9008 47.2436 18.9008C44.0843 18.9008 41.5415 21.4156 41.5415 24.5117C41.5415 27.5446 43.9687 30.0088 47.0253 30.1099ZM41.0277 42.1908C37.9198 40.1563 37.9198 36.8201 41.0277 34.7729C44.5722 32.4603 50.3642 32.4603 53.8831 34.7729C56.991 36.8075 56.991 40.1436 53.8831 42.1908C50.3514 44.516 44.5594 44.516 41.0277 42.1908Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_212_3178",
    x: 19.9464,
    y: 1.48651,
    width: 96.7133,
    height: 60.3412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.66387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3178",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86555,
    result: "effect2_foregroundBlur_212_3178"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_212_3178",
    x: 5.34454,
    y: -13.6411,
    width: 128.311,
    height: 92.3109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.32773
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_212_3178",
    x: 66.5,
    y: 21.5,
    width: 40,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_212_3178",
    x: 67,
    y: 30,
    width: 39,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_212_3178",
    x: 66.7109,
    y: 38.1083,
    width: 23.2637,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_212_3178",
    x: 37.6968,
    y: 18.9008,
    width: 19.5171,
    height: 27.0339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_3178",
    x1: 68.7975,
    y1: 12.0966,
    x2: 68.7975,
    y2: 50.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_212_3178",
    x1: 69.5,
    y1: 5.0144,
    x2: 69.5,
    y2: 60.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidDocumentCut);
export default __webpack_public_path__ + "static/media/bfid-document-cut.1aeec08b9672e8eac80ae8f5685856f9.svg";
export { ForwardRef as ReactComponent };